// @flow
import { selectRawProductsArray, selectCartProductOwner } from '@gandi/cart';
import { selectOneOrganization } from '@gandi/redux-organization';

import type { FullState } from '../../../../types';

export const selectProductOwnerName = (state: FullState): string => {
  const productOwner = selectCartProductOwner(state);
  if (!productOwner) {
    return '';
  }

  const productOrg = selectOneOrganization(state, productOwner);
  if (!productOrg) {
    return '';
  }

  return productOrg.name;
};

export const selectHasDomainWithIdn = (state: FullState): boolean =>
  selectRawProductsArray(state).some(
    product =>
      product.productType === 'domain' &&
      product.process === 'create' &&
      !!product.payload.lang,
  );
